import React from 'react';
import { Button, Input, InputGroup } from 'reactstrap';
import { observer } from 'mobx-react';
import { observable, action, makeObservable } from 'mobx';
import { InputProps } from 'reactstrap';
import './PasswordInput.scss';

type PasswordInputProps = Omit<InputProps, 'type'>;

@observer
export default class PasswordInput extends React.Component<PasswordInputProps> {
    @observable private isPasswordVisible = false;

    constructor(props: PasswordInputProps) {
        super(props);
        makeObservable(this);
    }

    @action
    private showPassword = () => {
        this.isPasswordVisible = true;
    };

    @action
    private hidePassword = () => {
        this.isPasswordVisible = false;
    };

    @action
    private handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault(); // Prevent default space/enter behavior
            this.showPassword();
        }
    };

    @action
    private handleKeyUp = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
            this.hidePassword();
        }
    };

    render() {
        const { ...inputProps } = this.props;

        return (
            <InputGroup className="passwordInput">
                <Input {...inputProps} type={this.isPasswordVisible ? 'text' : 'password'} />
                <Button
                    color="outline-secondary"
                    type="button"
                    onMouseDown={this.showPassword}
                    onMouseUp={this.hidePassword}
                    onMouseLeave={this.hidePassword}
                    onKeyDown={this.handleKeyDown}
                    onKeyUp={this.handleKeyUp}
                    onBlur={this.hidePassword}
                    title="Hold to show password"
                    aria-label="Hold to show password"
                >
                    <i className="ion ion-md-eye" />
                </Button>
            </InputGroup>
        );
    }
}
